import axios from 'axios';
import React, { useState, useContext, useEffect } from "react";
import apiPath from "../constants/apiPath";
import { BASE_URL } from '../constants/api_urls';
import { AuthContext } from "../context/AuthContext";

const client = axios.create({
    baseURL: apiPath.baseURL,
  });

const useRequest = () => {
    const { logout } = useContext(AuthContext)
    const request = async ({ url, method: tmethod, data, onSuccess, onError, header, onErrorSubmit }) => {
        const method = tmethod.trim().toUpperCase()
        let token = localStorage.getItem("token") ? localStorage.getItem("token") : '';
        let guestId = localStorage.getItem("guestId") || "";

        const headers = {
            ...header,
            ...(guestId ? { "guest-id": guestId } : {}), 
            Authorization: `Bearer ${token}`
        };

        try {

            const response = await client({
                url,
                method,
                data,
                headers: { ...headers },
            })

            if (response && response.data) {

            if (onSuccess) {
                onSuccess(response.data)
            }
            if (onError && response.data.status !== 200) {
                onError(response.data);
                console.log(response.data, "onError Jay");
            }
            return response.data;
            }
            else {
                onErrorSubmit(response.data)
            }
        }
        catch (err) {
        console.log(err,"err.respons")
        if (err.response) {
            if (err.response.status === 401) {
                logout();
            } else if (err.response.status === 403) {
                onError(err);
            } else if (err.response.status === 406) {
                console.log("err 406",err.response.data.message);
                onError(err.response.data);
            } else if (err.response.data.message === "jwt expired") {
                logout();
            } else if (err.response.data.message === "connection timed out") {
                logout();
            }
            if (onError) {
                onError(err);
            }
        }else {
            // Handle cases where there's no response (e.g., network error, timeout)
            console.error("No response received:", err);
            if (onError) {
                onError(err);  // Pass the error to onError callback if it's defined
            }
        }
            // throw err;
        }
    }

    return { request }
};

export default useRequest;